(() => {
  const TRIGGER_SELECTOR =
    '[data-floating-filter-trigger]';

  const DESKTOP_FILTERS_SELECTOR =
    '#FacetsWrapperDesktop';

  const MOBILE_TRIGGER_SELECTOR =
    '.mobile-facets__wrapper .mobile-facets__open-wrapper';

  const MOBILE_DRAWER_SELECTOR =
    '.mobile-facets__wrapper details.mobile-facets__disclosure';

  const MOBILE_CLOSE_SELECTOR =
    '.mobile-facets__wrapper .mobile-facets__close';

  const MOBILE_BREAKPOINT = 989;
  const SHOW_AFTER_SCROLL = 320;
  const HIDE_BEFORE_PAGE_END = 400;

  /*
   * Aumenta questo valore per far salire
   * maggiormente la pagina su desktop.
   */
  const DESKTOP_EXTRA_OFFSET = 180;

  let savedMobileScrollPosition = null;

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getCurrentScrollPosition() {
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      0
    );
  }

  function getHeaderOffset() {
    const header =
      document.querySelector('.header-wrapper') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');

    return header
      ? header.getBoundingClientRect().height + 20
      : 20;
  }

 function updateButtonVisibility() {
  const currentScroll =
    window.scrollY ||
    document.documentElement.scrollTop ||
    0;

  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );

  const remainingDistance =
    documentHeight -
    (currentScroll + window.innerHeight);

  const hasScrolledEnough =
    currentScroll >= SHOW_AFTER_SCROLL;

  const isNearPageEnd =
    remainingDistance <= HIDE_BEFORE_PAGE_END;

  const shouldShow =
    hasScrolledEnough &&
    !isNearPageEnd;

  document
    .querySelectorAll(TRIGGER_SELECTOR)
    .forEach((button) => {
      button.classList.toggle(
        'is-visible',
        shouldShow
      );

      button.setAttribute(
        'aria-hidden',
        shouldShow ? 'false' : 'true'
      );

      button.tabIndex = shouldShow ? 0 : -1;
    });
}

  /**
   * Ripristina la posizione della pagina più volte.
   * Serve perché il tema può spostare lo scroll
   * durante l'animazione di apertura o chiusura.
   */
  function restoreMobileScroll(position) {
    if (
      typeof position !== 'number' ||
      Number.isNaN(position)
    ) {
      return;
    }

    const htmlElement = document.documentElement;
    const previousScrollBehavior =
      htmlElement.style.scrollBehavior;

    htmlElement.style.scrollBehavior = 'auto';

    const restore = () => {
      window.scrollTo({
        top: position,
        left: 0,
        behavior: 'auto'
      });
    };

    restore();

    requestAnimationFrame(() => {
      restore();

      requestAnimationFrame(() => {
        restore();
      });
    });

    window.setTimeout(restore, 60);
    window.setTimeout(restore, 150);
    window.setTimeout(restore, 300);

    window.setTimeout(() => {
      htmlElement.style.scrollBehavior =
        previousScrollBehavior;
    }, 350);
  }

  /**
   * Mobile:
   * apre il pannello senza spostare la pagina.
   */
  function openMobileFilters() {
    const mobileTrigger = document.querySelector(
      MOBILE_TRIGGER_SELECTOR
    );

    if (!mobileTrigger) {
      return;
    }

    const drawerDetails =
      mobileTrigger.closest('details');

    if (drawerDetails?.open) {
      return;
    }

    savedMobileScrollPosition =
      getCurrentScrollPosition();

    mobileTrigger.click();

    restoreMobileScroll(
      savedMobileScrollPosition
    );
  }

  /**
   * Desktop:
   * scorre più in alto per mostrare
   * completamente la barra dei filtri.
   */
  function scrollToDesktopFilters() {
    const filters = document.querySelector(
      DESKTOP_FILTERS_SELECTOR
    );

    if (!filters) {
      return;
    }

    const targetPosition =
      filters.getBoundingClientRect().top +
      window.scrollY -
      getHeaderOffset() -
      DESKTOP_EXTRA_OFFSET;

    window.scrollTo({
      top: Math.max(targetPosition, 0),
      behavior: 'smooth'
    });

    filters.classList.remove(
      'floating-filter-target-highlight'
    );

    requestAnimationFrame(() => {
      filters.classList.add(
        'floating-filter-target-highlight'
      );
    });

    window.setTimeout(() => {
      filters.classList.remove(
        'floating-filter-target-highlight'
      );
    }, 900);
  }

  function handleFloatingFilterClick(event) {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const button = target.closest(
      TRIGGER_SELECTOR
    );

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (isMobileViewport()) {
      openMobileFilters();
      return;
    }

    scrollToDesktopFilters();
  }

  /**
   * Quando viene cliccata la X del pannello mobile,
   * lascia chiudere normalmente il drawer e poi
   * riporta la pagina alla posizione precedente.
   */
  function handleMobileCloseClick(event) {
    if (!isMobileViewport()) {
      return;
    }

    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const closeButton = target.closest(
      MOBILE_CLOSE_SELECTOR
    );

    if (!closeButton) {
      return;
    }

    const positionToRestore =
      savedMobileScrollPosition;

    /*
     * Non usare preventDefault:
     * il tema deve poter chiudere il drawer.
     */
    window.setTimeout(() => {
      restoreMobileScroll(positionToRestore);
    }, 0);

    window.setTimeout(() => {
      restoreMobileScroll(positionToRestore);
    }, 180);
  }

  /**
   * Controllo aggiuntivo sulla chiusura del drawer.
   * Copre anche chiusure eseguite dal tema.
   */
  function handleMobileDrawerToggle(event) {
    const drawer = event.target;

    if (
      !(drawer instanceof HTMLDetailsElement) ||
      !drawer.matches(MOBILE_DRAWER_SELECTOR)
    ) {
      return;
    }

    if (drawer.open) {
      if (savedMobileScrollPosition === null) {
        savedMobileScrollPosition =
          getCurrentScrollPosition();
      }

      restoreMobileScroll(
        savedMobileScrollPosition
      );

      return;
    }

    const positionToRestore =
      savedMobileScrollPosition;

    restoreMobileScroll(positionToRestore);

    window.setTimeout(() => {
      restoreMobileScroll(positionToRestore);
      savedMobileScrollPosition = null;
    }, 350);
  }

  /**
 * Quando viene applicato o modificato un filtro mobile,
 * non deve più essere ripristinata la vecchia posizione.
 */
function handleMobileFilterChange(event) {
  if (!isMobileViewport()) {
    return;
  }

  const target = event.target;

  if (!(target instanceof Element)) {
    return;
  }

  const mobileForm = target.closest(
    '#FacetFiltersFormMobile'
  );

  if (!mobileForm) {
    return;
  }

  savedMobileScrollPosition = null;
}

  document.addEventListener(
    'click',
    handleFloatingFilterClick,
    true
  );

  document.addEventListener(
    'click',
    handleMobileCloseClick,
    true
  );

  document.addEventListener(
    'toggle',
    handleMobileDrawerToggle,
    true
  );

  document.addEventListener(
  'change',
  handleMobileFilterChange,
  true
);

  window.addEventListener(
    'scroll',
    updateButtonVisibility,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    updateButtonVisibility
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateButtonVisibility
    );
  } else {
    updateButtonVisibility();
  }

  document.addEventListener(
    'shopify:section:load',
    updateButtonVisibility
  );
})();